var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg013Driver(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "32px",
    viewBox: "0 0 27 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.91,20.1672 L21.704,20.1672 L22.3,22.1312 C22.663,22.2672 23.002,22.4522 23.308,22.6812 L25.41,22.1852 L26.307,23.6502 L24.799,25.1202 C24.828,25.3012 24.844,25.4842 24.844,25.6672 C24.844,25.8502 24.828,26.0332 24.799,26.2142 L26.306,27.6842 L25.409,29.1492 L23.306,28.6532 C23.001,28.8812 22.661,29.0662 22.299,29.2032 L21.704,31.1672 L19.91,31.1672 L19.314,29.2042 C18.951,29.0672 18.612,28.8822 18.306,28.6542 L16.204,29.1502 L15.307,27.6852 L16.815,26.2142 C16.753,25.8522 16.753,25.4822 16.815,25.1202 L15.308,23.6512 L16.205,22.1852 L18.308,22.6812 C18.614,22.4532 18.953,22.2672 19.315,22.1312 L19.91,20.1672 Z M19.307,25.6672 C19.307,26.4962 19.979,27.1672 20.807,27.1672 C21.636,27.1672 22.307,26.4962 22.307,25.6672 C22.307,24.8392 21.636,24.1672 20.807,24.1672 C19.979,24.1672 19.307,24.8392 19.307,25.6672 Z",
    id: "Combined-Shape",
    fill: "#3FAE29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.76,18.2874 C16.68,18.2974 13.39,21.5974 13.39,25.6674 L0,25.6674 L0,18.6374 C0,15.4374 2.58,12.8574 5.78,12.8574 L15.1,12.8574 C18.15,12.8574 20.64,15.2674 20.76,18.2874",
    id: "Fill-6",
    fill: "#3FAE29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.63,5.25 C15.63,8.149 13.279,10.5 10.38,10.5 C7.481,10.5 5.13,8.149 5.13,5.25 C5.13,2.351 7.481,0 10.38,0 C13.279,0 15.63,2.351 15.63,5.25",
    id: "Fill-8",
    fill: "#3FAE29"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(15.000000, 20.167200)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg013Driver);
export default __webpack_public_path__ + "static/media/013-driver.f57e42d1543525e24ebdf049d63db741.svg";
export { ForwardRef as ReactComponent };